// extracted by mini-css-extract-plugin
export default {"font_button_l":"font_button_l___Scz_H","font_button_m":"font_button_m___iiYcO","font_button_s":"font_button_s___aUU1S","oculus_navbar":"oculus_navbar___uocoI"};